import axios from 'axios';
import type { Store } from 'vuex/types/index.js';
import type { Router } from 'vue-router';
import { getHomePath } from '..';

export default (store: Store<unknown>, router: Router): void => {
  axios.interceptors.request.use(
    config => config,
    error => Promise.reject(error),
  );

  axios.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = { ...error.config };
      const isRefreshTokenRequest = originalRequest.url?.includes('/users/refresh-token');
      if (error.response?.status === 401) {
        if (originalRequest._retry || isRefreshTokenRequest) {
          try {
            await store.dispatch('login/LOGOUT');
            await router.push({ path: getHomePath() });
          } catch (err) {
            console.error(err);
          }
        } else {
          await store.dispatch('login/refreshToken');
          originalRequest.headers.Authorization = `Bearer ${store.getters['login/accessToken']}`;
          originalRequest._retry = true;
          return axios(originalRequest);
        }
      } else if (error.response?.status === 403 && error.response?.data?.message === 'Not verified') {
        await router.push({ name: 'phoneValidation', query: { redirect: router.currentRoute.value.fullPath } });
      }
      return Promise.reject(error.response);
    },
  );
};
